<template>
    <div>
      <div class="loader" v-if="this.isLoading"></div>   
      <div class="loadertext" v-if="this.isLoading"> {{$t('loadingTxt')}}...</div>   
      <div class="main-wrapper" :class="{'blur-content': this.isLoading}">
  
          <!--begin::navbar-->
          <navbar-component></navbar-component>
          <!--end::navbar-->
  
        <div class="page-wrapper">
  
          <!--begin::content-->
          <div class="page-content">
            <div class="row">
              <div>
                <h4 class="mb-12 mb-md-0"></h4>
              </div>
  
              <div class="col-lg-12 col-xl-12 stretch-card">
                <div class="card">
                    <div class="card-header">
                        <div class="row mb-3">
                            <h4 style="margin-right: 5px" class="float-start">{{ $t("cml_billing_detail_handling_extra_handling") }}</h4>
                        </div>
                        <div class="card-body">
                            <div class="row mb-3">
                                <div class="col-md-3">
                                    <label class="form-label">{{$t('idBillingDetail')}}</label>
                                    <input
                                    type="text"
                                    class="form-control"
                                    id="idBillingDetail"
                                    :placeholder="$t('idBillingDetail')"
                                    v-model="forms.idBillingDetail"
                                    disabled
                                    />
                                </div>
                                <div class="col-md-3">
                                    <label class="form-label">{{$t('idBillingHeader')}}</label>
                                    <input
                                    type="text"
                                    class="form-control"
                                    id="idBillingHeader"
                                    :placeholder="$t('idBillingHeader')"
                                    v-model="forms.idBillingHeader"
                                    disabled
                                    />
                                </div>
                                <div class="col-md-3">
                                    <label class="form-label">{{$t('SAPMaterialCode')}}</label>
                                    <input
                                    type="text"
                                    class="form-control"
                                    id="SAPMaterialCode"
                                    :placeholder="$t('SAPMaterialCode')"
                                    v-model="forms.SAPMaterialCode"
                                    disabled
                                    />
                                </div>
                                <div class="col-md-3">
                                    <label class="form-label">{{$t('SAPDivision')}}</label>
                                    <input
                                    type="text"
                                    class="form-control"
                                    id="SAPDivision"
                                    :placeholder="$t('SAPDivision')"
                                    v-model="forms.SAPDivision"
                                    disabled
                                    />
                                </div>
                            </div>   
                            <div class="row mb-3">
                                <div class="col-md-3">
                                    <label class="form-label">{{$t('chargeCategory_txt')}}</label>
                                    <input
                                    type="text"
                                    class="form-control"
                                    id="chargeCategory"
                                    :placeholder="$t('chargeCategory_txt')"
                                    v-model="forms.chargeCategory"
                                    disabled
                                    />
                                </div>
                                <div class="col-md-3">
                                    <label class="form-label">{{$t('chargeType_txt')}}</label>
                                    <input
                                    type="text"
                                    class="form-control"
                                    id="chargeType"
                                    :placeholder="$t('chargeType_txt')"
                                    v-model="forms.chargeType"
                                    disabled
                                    />
                                </div>
                                <div class="col-md-6">
                                    <label class="form-label">{{$t('rateBaseDesc_txt')}}</label>
                                    <input
                                    type="text"
                                    class="form-control"
                                    id="rateBaseDesc"
                                    :placeholder="$t('rateBaseDesc_txt')"
                                    v-model="forms.rateBaseDesc"
                                    disabled
                                    />
                                </div>
                            </div>    
                            <div class="row mb-3">
                                <div class="col-md-3">
                                    <label class="form-label">{{$t('qtyCharge')}}</label>
                                    <input
                                    type="text"
                                    class="form-control"
                                    id="qtyCharge"
                                    :placeholder="$t('qtyCharge')"
                                    v-model="forms.qtyCharge"
                                    disabled
                                    />
                                </div>
                                <div class="col-md-3">
                                    <label class="form-label">{{$t('rate')}}</label>
                                    <input
                                    type="text"
                                    class="form-control"
                                    id="rate"
                                    :placeholder="$t('rate')"
                                    v-model="forms.rate"
                                    disabled
                                    />
                                </div>
                                <div class="col-md-3">
                                    <label class="form-label">{{$t('amountCategory')}}</label>
                                    <input
                                    type="text"
                                    class="form-control"
                                    id="amountCategory"
                                    :placeholder="$t('amountCategory')"
                                    v-model="forms.amountCategory"
                                    disabled
                                    />
                                </div>
                                <div class="col-md-3">
                                    <label class="form-label">{{$t('remarks_txt')}}</label>
                                    <input
                                    type="text"
                                    class="form-control"
                                    id="remark"
                                    :placeholder="$t('remarks_txt')"
                                    v-model="forms.remark"
                                    disabled
                                    />
                                </div>
                            </div>    
                        </div>
                        <button
                        v-if="permision_role.method_read"
                        class="btn btn-success float-end btn-xs"
                        style="margin-right: 5px"
                        @click.prevent="downloadData()"
                        >
                        <span class="mdi mdi-download h4"></span>
                        {{ $t("downloadData") }} .xlsx
                        </button>
                        <button
                        class="
                        btn btn-primary
                        text-light
                        fw-bolder
                        btn-icon-text
                        "
                        @click="backForm"
                        type="button"
                    >
                        <i class="link-icon mdi mdi-arrow-left"></i>
                        {{ $t("backMess") }}
                        </button>
                    </div>
  
                    <div class="card-body" v-if="this.formsHeader.status === 'COMPLETED'">
                        <vue-good-table
                        title="list-billing-cml-billing-detail-handling-extra"
                        ref="list-billing-cml-billing-detail-handling-extra"
                        :select-options="{enabled: true, selectOnCheckboxOnly: true,selectionText: $t('data_selected'),clearSelectionText: $t('clear'),}"
                        mode="remote"
                        @on-selected-rows-change="selectionChanged"
                        @on-page-change="onPageChange"
                        @on-sort-change="onSortChange"
                        @on-column-filter="onColumnFilter"
                        @on-per-page-change="onPerPageChange"
                        :totalRows="totalRecords"
                        :line-numbers="true"
                        :isLoading.sync="isLoading"
                        :pagination-options="{
                            enabled: true,
                            perPageDropdown: [10, 50, 100, 1000, 10000],
                            dropdownAllowAll: false,
                        }"
                        :rows="rows"
                        :columns="columns"
                        >
                            <div slot="table-actions">
                                {{ $t("no_select_data") }}
                            </div>
                            <div slot="selected-row-actions">
                                <button class="btn btn-danger btn-xs" style="margin-right:20px;" @click="selectionChangeStatus"> <i
                                    class="mdi mdi-send-outline"></i> {{ $t("changeStatus") }}</button>
                                <button class="btn btn-success btn-xs" @click="removeSelections"><i class="mdi mdi-close"></i> {{
                                    $t("unselect_data_txt")
                                }} </button>
                            </div>
                            <template slot="table-row" slot-scope="props">
                                <span v-if="props.column.field == 'actions'">
                                    <a href="#" v-if="permision_role.method_update && props.row.status === 'BILL'" title="NOT BILL" @click.prevent=" changeStatusData(props.index, props.row , 'NOT BILL')">
                                        <button class="btn btn-danger btn-xs">NOT BILL</button>
                                    </a>
                                    <a href="#" v-else @click.prevent="changeStatusData(props.index, props.row, 'BILL')">
                                        <button class="btn btn-primary btn-xs">BILL</button>
                                    </a>
                                </span>
                                <span v-else-if="props.column.field == 'basicSalary'">
                                    {{toCurrency(props.row.basicSalary)}}
                                </span>
                                <span v-else-if="props.column.field == 'rateOt'">
                                    {{toCurrency(props.row.rateOt)}}
                                </span>
                                <span v-else-if="props.column.field == 'tunjangan'">
                                    {{toCurrency(props.row.tunjangan)}}
                                </span>
                                <span v-else-if="props.column.field == 'totalHourOt'">
                                    {{toNumber(props.row.totalHourOt)}}
                                </span>
                                <span v-else-if="props.column.field == 'adjustmentUp'">
                                    {{toCurrency(props.row.adjustmentUp)}}
                                </span>
                                <span v-else-if="props.column.field == 'adjustmentDown'">
                                    {{toCurrency(props.row.adjustmentDown)}}
                                </span>
                                <span v-else-if="props.column.field == 'subTotal'">
                                    {{toCurrency(props.row.subTotal)}}
                                </span>
                                <span v-else-if="props.column.field == 'bpjsTk'">
                                    {{toCurrency(props.row.bpjsTk)}}
                                </span>
                                <span v-else-if="props.column.field == 'bpjsKes'">
                                    {{toCurrency(props.row.bpjsKes)}}
                                </span>
                                <span v-else-if="props.column.field == 'jaminanPensiun'">
                                    {{toCurrency(props.row.jaminanPensiun)}}
                                </span>
                                <span v-else-if="props.column.field == 'totalKotor'">
                                    {{toCurrency(props.row.totalKotor)}}
                                </span>
                                <span v-else-if="props.column.field == 'amountManagement'">
                                    {{toCurrency(props.row.amountManagement)}}
                                </span>
                                <span v-else-if="props.column.field == 'amountPph'">
                                    {{toCurrency(props.row.amountPph)}}
                                </span>
                                <span v-else-if="props.column.field == 'grandTotal'">
                                    {{toCurrency(props.row.grandTotal)}}
                                </span>
                                <span v-else-if="props.column.field == 'salary'">
                                    {{toCurrency(props.row.salary)}}
                                </span>
                                <span v-else-if="props.column.field == 'amountOt'">
                                    {{toCurrency(props.row.amountOt)}}
                                </span>
                                <span v-else-if="props.column.field == 'amountPpn'">
                                    {{toCurrency(props.row.amountPpn)}}
                                </span>
                                <span v-else-if="props.column.field == 'status'">
                                    <span v-if="props.row.status == 'BILL'" class="badge bg-primary"><h5>{{props.row.status}}</h5></span>
                                    <span v-else class="badge bg-danger"><h5>{{props.row.status}}</h5></span>
                                </span>
                                <span v-else>
                                    {{ props.formattedRow[props.column.field] }}
                                </span>
                            </template>
                            
                        </vue-good-table>
                    </div>
                    <div class="card-body" v-else>
                        <vue-good-table
                        title="list-billing-cml-billing-detail-handling-extra"
                        ref="list-billing-cml-billing-detail-handling-extra"
                        mode="remote"
                        @on-selected-rows-change="selectionChanged"
                        @on-page-change="onPageChange"
                        @on-sort-change="onSortChange"
                        @on-column-filter="onColumnFilter"
                        @on-per-page-change="onPerPageChange"
                        :totalRows="totalRecords"
                        :line-numbers="true"
                        :isLoading.sync="isLoading"
                        :pagination-options="{
                            enabled: true,
                            perPageDropdown: [10, 50, 100, 1000, 10000],
                            dropdownAllowAll: false,
                        }"
                        :rows="rows"
                        :columns="columns"
                        >
                            <div slot="table-actions">
                                {{ $t("no_select_data") }}
                            </div>
                            <template slot="table-row" slot-scope="props">
                                <span v-if="props.column.field == 'actions'">
                                    -
                                </span>
                                <span v-else-if="props.column.field == 'basicSalary'">
                                    {{toCurrency(props.row.basicSalary)}}
                                </span>
                                <span v-else-if="props.column.field == 'rateOt'">
                                    {{toCurrency(props.row.rateOt)}}
                                </span>
                                <span v-else-if="props.column.field == 'tunjangan'">
                                    {{toCurrency(props.row.tunjangan)}}
                                </span>
                                <span v-else-if="props.column.field == 'totalHourOt'">
                                    {{toNumber(props.row.totalHourOt)}}
                                </span>
                                <span v-else-if="props.column.field == 'adjustmentUp'">
                                    {{toCurrency(props.row.adjustmentUp)}}
                                </span>
                                <span v-else-if="props.column.field == 'adjustmentDown'">
                                    {{toCurrency(props.row.adjustmentDown)}}
                                </span>
                                <span v-else-if="props.column.field == 'subTotal'">
                                    {{toCurrency(props.row.subTotal)}}
                                </span>
                                <span v-else-if="props.column.field == 'bpjsTk'">
                                    {{toCurrency(props.row.bpjsTk)}}
                                </span>
                                <span v-else-if="props.column.field == 'bpjsKes'">
                                    {{toCurrency(props.row.bpjsKes)}}
                                </span>
                                <span v-else-if="props.column.field == 'jaminanPensiun'">
                                    {{toCurrency(props.row.jaminanPensiun)}}
                                </span>
                                <span v-else-if="props.column.field == 'totalKotor'">
                                    {{toCurrency(props.row.totalKotor)}}
                                </span>
                                <span v-else-if="props.column.field == 'amountManagement'">
                                    {{toCurrency(props.row.amountManagement)}}
                                </span>
                                <span v-else-if="props.column.field == 'amountPph'">
                                    {{toCurrency(props.row.amountPph)}}
                                </span>
                                <span v-else-if="props.column.field == 'grandTotal'">
                                    {{toCurrency(props.row.grandTotal)}}
                                </span>
                                <span v-else-if="props.column.field == 'salary'">
                                    {{toCurrency(props.row.salary)}}
                                </span>
                                <span v-else-if="props.column.field == 'amountOt'">
                                    {{toCurrency(props.row.amountOt)}}
                                </span>
                                <span v-else-if="props.column.field == 'amountPpn'">
                                    {{toCurrency(props.row.amountPpn)}}
                                </span>
                                <span v-else-if="props.column.field == 'status'">
                                    <span v-if="props.row.status == 'BILL'" class="badge bg-primary"><h5>{{props.row.status}}</h5></span>
                                    <span v-else class="badge bg-danger"><h5>{{props.row.status}}</h5></span>
                                </span>
                                <span v-else>
                                    {{ props.formattedRow[props.column.field] }}
                                </span>
                            </template>

                        </vue-good-table>
                    </div>

                </div>
              </div>
            </div>
          </div>
          <!--end::content-->
  
          <!--begin::footer-->
          <footer-component></footer-component>
          <!--end::footer-->
        </div>
      </div>
    </div>
</template>
  
<script>
    import navbarComponent from "@/components/_partials/_navbar";
    import footerComponent from "@/components/_partials/_footer";
  
    export default {
        name: "CmlBillingDetailExtraHandling",
        components: {
        "navbar-component": navbarComponent,
        "footer-component": footerComponent,
        },
        data() {
        return {
               
                maxToasts: 100,
                position: "up right",
                closeBtn: true,
                isLoading: false,
                errors: [],
                permision_role:[],
                langs: ["id", "en"],
                detailUser: [],
                idBillingHeader:[],
                detailDivisi: [],
                totalRecords: 0,
                startOvertimeFrom:"",
                firstBilingDate:"",
                startOvertimeTo:"",
                endOvertimeFrom:"",
                endOvertimeTo:"",
                serverParams: {
                columnFilters: {},
                sort: {
                    field: "",
                    type: "",
                },
                page: 1,
                per_page: 10,
                },
                columns: [
                    {
                        label: this.$t("idDetail_ExtraHandling"),
                        field: "idDetail_ExtraHandling",
                        width: '100px',
                        thClass: 'text-center',
                        filterOptions: {
                        enabled: true, // enable filter for this column
                        customFilter: false,
                        placeholder: this.$t("idDetail_ExtraHandling"), // placeholder for filter input
                        filterValue: "", // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        trigger: "enter", //only trigger on enter not on keyup
                        },
                    },
                    {
                        label: this.$t("statusTxt"),
                        field: "status",
                        width: '100px',
                        thClass: 'text-center',
                        filterOptions: {
                        enabled: true, // enable filter for this column
                        customFilter: false,
                        placeholder: this.$t("statusTxt"), // placeholder for filter input
                        filterValue: "", // initial populated value for this filter
                        filterDropdownItems: ['BILL','NOT BILL'], // dropdown (with selected values) instead of text input
                        trigger: "enter", //only trigger on enter not on keyup
                        },
                    },
                    {
                        label: this.$t("transactionType"),
                        field: "transactionType",
                        width: '150px',
                        thClass: 'text-center',
                        filterOptions: {
                        enabled: true, // enable filter for this column
                        customFilter: false,
                        placeholder: this.$t("transactionType"), // placeholder for filter input
                        filterValue: "", // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        trigger: "enter", //only trigger on enter not on keyup
                        },
                    },
                    {
                        label: this.$t("nameTxt"),
                        field: "employeeName",
                        width: '150px',
                        thClass: 'text-center',
                        filterOptions: {
                        enabled: true, // enable filter for this column
                        customFilter: false,
                        placeholder: this.$t("nameTxt"), // placeholder for filter input
                        filterValue: "", // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        trigger: "enter", //only trigger on enter not on keyup
                        },
                    },
                    {
                        label: this.$t("nik"),
                        field: "nik",
                        width: '100px',
                        thClass: 'text-center',
                        filterOptions: {
                        enabled: true, // enable filter for this column
                        customFilter: false,
                        placeholder: this.$t("nik"), // placeholder for filter input
                        filterValue: "", // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        trigger: "enter", //only trigger on enter not on keyup
                        },
                    },
        
                    
                    {
                        label: this.$t("totalHourOt"),
                        field: "totalHourOt",
                        width: '100px',
                        thClass: 'text-center',
                        filterOptions: {
                        enabled: false, // enable filter for this column
                        customFilter: false,
                        },
                    },     

                    {
                        label: this.$t("rateOt"),
                        field: "rateOt",
                        thClass: 'text-center',
                        filterOptions: {
                        enabled: false, // enable filter for this column
                        customFilter: false,
                        },
                    },       

                    {
                        label: this.$t("amountOt"),
                        field: "amountOt",
                        thClass: 'text-center',
                        filterOptions: {
                        enabled: false, // enable filter for this column
                        customFilter: false,
                        },
                    }, 
        
                    {
                        label: this.$t("action_txt"),
                        field: "actions",
                        width: '100px',
                        thClass: 'text-center',
                        sortable: false,
                        filterOptions: {
                            customFilter: false,
                            enabled: false, 
                        },
                    },
                    
        
                    {
                        label: this.$t("totalWorkDay"),
                        field: "totalWorkDay",
                        width: '100px',
                        thClass: 'text-center',
                        filterOptions: {
                        enabled: false, // enable filter for this column
                        customFilter: false,
                        },
                    },       

                    {
                        label: this.$t("basicSalary"),
                        field: "basicSalary",
                        width: '100px',
                        thClass: 'text-center',
                        filterOptions: {
                        enabled: false, // enable filter for this column
                        customFilter: false,
                        },
                    },       

                    {
                        label: this.$t("salary"),
                        field: "salary",
                        width: '100px',
                        thClass: 'text-center',
                        filterOptions: {
                        enabled: false, // enable filter for this column
                        customFilter: false,
                        },
                    },       
                    

                    {
                        label: this.$t("tunjangan"),
                        field: "tunjangan",
                        width: '100px',
                        thClass: 'text-center',
                        filterOptions: {
                        enabled: false, // enable filter for this column
                        customFilter: false,
                        },
                    },    
                          
                         


                    {
                        label: this.$t("adjustmentUp"),
                        field: "adjustmentUp",
                        width: '100px',
                        thClass: 'text-center',
                        filterOptions: {
                        enabled: false, // enable filter for this column
                        customFilter: false,
                        },
                    },       

                    {
                        label: this.$t("adjustmentDown"),
                        field: "adjustmentDown",
                        width: '100px',
                        thClass: 'text-center',
                        filterOptions: {
                        enabled: false, // enable filter for this column
                        customFilter: false,
                        },
                    },       

                    {
                        label: this.$t("subTotal"),
                        field: "subTotal",
                        width: '100px',
                        thClass: 'text-center',
                        filterOptions: {
                        enabled: false, // enable filter for this column
                        customFilter: false,
                        },
                    },       

                    {
                        label: this.$t("bpjsTk"),
                        field: "bpjsTk",
                        width: '100px',
                        thClass: 'text-center',
                        filterOptions: {
                        enabled: false, // enable filter for this column
                        customFilter: false,
                        },
                    },       

                    {
                        label: this.$t("bpjsKes"),
                        field: "bpjsKes",
                        width: '100px',
                        thClass: 'text-center',
                        filterOptions: {
                        enabled: false, // enable filter for this column
                        customFilter: false,
                        },
                    },       

                    {
                        label: this.$t("jaminanPensiun"),
                        field: "jaminanPensiun",
                        width: '100px',
                        thClass: 'text-center',
                        filterOptions: {
                        enabled: false, // enable filter for this column
                        customFilter: false,
                        },
                    },       

                    {
                        label: this.$t("totalKotor"),
                        field: "totalKotor",
                        width: '100px',
                        thClass: 'text-center',
                        filterOptions: {
                        enabled: false, // enable filter for this column
                        customFilter: false,
                        },
                    },       

                    {
                        label: this.$t("rateManagement"),
                        field: "rateManagement",
                        width: '100px',
                        thClass: 'text-center',
                        filterOptions: {
                        enabled: false, // enable filter for this column
                        customFilter: false,
                        },
                    },       

                    {
                        label: this.$t("amountManagement"),
                        field: "amountManagement",
                        width: '100px',
                        thClass: 'text-center',
                        filterOptions: {
                        enabled: false, // enable filter for this column
                        customFilter: false,
                        },
                    },       

                    {
                        label: this.$t("ppH"),
                        field: "ppH",
                        width: '100px',
                        thClass: 'text-center',
                        filterOptions: {
                        enabled: false, // enable filter for this column
                        customFilter: false,
                        },
                    },       

                    {
                        label: this.$t("amountPph"),
                        field: "amountPph",
                        width: '100px',
                        thClass: 'text-center',
                        filterOptions: {
                        enabled: false, // enable filter for this column
                        customFilter: false,
                        },
                    },       

                    {
                        label: this.$t("ppn"),
                        field: "ppn",
                        width: '100px',
                        thClass: 'text-center',
                        filterOptions: {
                        enabled: false, // enable filter for this column
                        customFilter: false,
                        },
                    },       

                    {
                        label: this.$t("amountPpn"),
                        field: "amountPpn",
                        width: '100px',
                        thClass: 'text-center',
                        filterOptions: {
                        enabled: false, // enable filter for this column
                        customFilter: false,
                        },
                    },       

                    {
                        label: this.$t("grandTotal"),
                        field: "grandTotal",
                        width: '100px',
                        thClass: 'text-center',
                        filterOptions: {
                        enabled: false, // enable filter for this column
                        customFilter: false,
                        },
                    },       

                    
                            
                    {
                        label: this.$t("editwho"),
                        field: "editwho",
                        width: '150px',
                        thClass: 'text-center',
                        filterOptions: {
                        enabled: true, // enable filter for this column
                        customFilter: false,
                        placeholder: this.$t("editwho"), // placeholder for filter input
                        filterValue: "", // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        trigger: "enter", //only trigger on enter not on keyup
                        },
                    },
                    
                    
                ],
                rows: [],
                rowsSelection:[],
                idCodeLkupsSelections:[],
                forms: {remark: "", rateBaseDesc: "", idBillingDetail: "",  idBillingHeader:"",  chargeCategory:"", chargeType:"", SAPMaterialCode:"", SAPDivision:"",  amountCategory:"" , addwho:"", editwho:"",  qtyCharge:"", rate:""},
                formsHeader: {idBillingHeader: "",  tariffId:"",  customerId:"", warehouseId:"", transactionToDate:"", transactionFromDate:"",  status:"" , amount:"", idRateHeader:"",  transactionDate:"", addwho:"",  editwho:"", adddate:"",  editdate:""},
                
            };
        },
        watch: {},
        methods: {

            changeStatusData(index, row , statusNya) {
                this.$swal({
                    title: this.$t("areYouSure"),
                    text: this.$t("yourData"),
                    showCancelButton: true,
                    confirmButtonColor: "#3085d6",
                    cancelButtonColor: "#d33",
                    confirmButtonText: "Yes!",
                }).then((result) => {
                    if (result.value) {
                    var formData = {
                        idBillingHeader: this.formsHeader.idBillingHeader,
                        idBillingDetail: this.forms.idBillingDetail,
                        idDetail_ExtraHandlings: [row.idDetail_ExtraHandling],
                        status: statusNya,
                    };
                    const baseURI =
                        this.$settings.endPointBilling + "dashboard/cml-billing/billing/bt-billing-detail-extra-handling-charge-update-status";
                    this.$http
                        .post(baseURI, formData,{ timeout: 60000 })
                        .then((response) => {
                        this.loading();
                        if (response.data.status === 200) {
                            this.success(response.data.datas.messages);
                            this.loadItems();

                        } else {
                            this.errors = response.data.errors;
                            this.resultError(response.data.errors);
                        }
                        }).catch((error) => {
                        this.loading();
                           
        if(error.code == "ECONNABORTED"){
            this.error(this.$t("check_internet_connection_txt"));
            
        }else{

            if (error.response) {
                if(error.response.status === 422) {
                    this.errors = error.response.data.errors;
                    this.resultError(error.response.data.errors);
                }else if (error.response.status === 401) {
                    this.logout();
                } else if (error.response.status === 403) {
                    this.$router.push("/authorized-error");
                }else if (error.response.status === 500) {
                    this.$router.push('/server-error');
                }else{
                    this.$router.push('/page-not-found');
                }
            }

        }
                        });
                    }else{
                    this.isLoading = false;
                    }
                });

            },

            selectionChangeStatus(){
                this.$swal({
                    title: this.$t("areYouSure"),
                    text: this.$t("yourDataSend"),
                    showCancelButton: true,
                    confirmButtonColor: "#3085d6",
                    cancelButtonColor: "#d33",
                    confirmButtonText: "BILL",
                    cancelButtonText: 'NOT BILL',
                }).then((result) => {
                    if (result.value) {
                        this.isLoading = true;

                        let formData = {
                            idBillingHeader: this.formsHeader.idBillingHeader,
                            idBillingDetail: this.forms.idBillingDetail,
                            idDetail_ExtraHandlings: this.idCodeLkupsSelections,
                            status: "BILL",
                        };
                        const baseURI =
                            this.$settings.endPointBilling + "dashboard/cml-billing/billing/bt-billing-detail-extra-handling-charge-update-status";
                        this.$http
                            .post(baseURI, formData,{ timeout: 60000 })
                            .then((response) => {
                            this.loading();
                            if (response.data.status === 200) {
                                this.success(response.data.datas.messages);
                                this.idCodeLkupsSelections = [];
                                this.loadItems();

                            } else {
                                this.errors = response.data.errors;
                                this.resultError(response.data.errors);
                            }
                            }).catch((error) => {
                            this.loading();
                               
        if(error.code == "ECONNABORTED"){
            this.error(this.$t("check_internet_connection_txt"));
            
        }else{

            if (error.response) {
                if(error.response.status === 422) {
                    this.errors = error.response.data.errors;
                    this.resultError(error.response.data.errors);
                }else if (error.response.status === 401) {
                    this.logout();
                } else if (error.response.status === 403) {
                    this.$router.push("/authorized-error");
                }else if (error.response.status === 500) {
                    this.$router.push('/server-error');
                }else{
                    this.$router.push('/page-not-found');
                }
            }

        }
                        });

                    }else{
                            
                        this.isLoading = true;
                        let formData = {
                            idBillingHeader: this.formsHeader.idBillingHeader,
                            idBillingDetail: this.forms.idBillingDetail,
                            idDetail_ExtraHandlings: this.idCodeLkupsSelections,
                            status: "NOT BILL",
                        };
                        const baseURI =
                            this.$settings.endPointBilling + "dashboard/cml-billing/billing/bt-billing-detail-extra-handling-charge-update-status";
                        this.$http
                            .post(baseURI, formData,{ timeout: 60000 })
                            .then((response) => {
                            this.loading();
                            if (response.data.status === 200) {
                                this.success(response.data.datas.messages);
                                this.idCodeLkupsSelections = [];
                                this.loadItems();

                            } else {
                                this.errors = response.data.errors;
                                this.resultError(response.data.errors);
                            }
                            }).catch((error) => {
                            this.loading();
                               
        if(error.code == "ECONNABORTED"){
            this.error(this.$t("check_internet_connection_txt"));
            
        }else{

            if (error.response) {
                if(error.response.status === 422) {
                    this.errors = error.response.data.errors;
                    this.resultError(error.response.data.errors);
                }else if (error.response.status === 401) {
                    this.logout();
                } else if (error.response.status === 403) {
                    this.$router.push("/authorized-error");
                }else if (error.response.status === 500) {
                    this.$router.push('/server-error');
                }else{
                    this.$router.push('/page-not-found');
                }
            }

        }
                        });


                    }
                });

            },

            removeSelections() {
                this.idCodeLkupsSelections = [];
                this.$refs['list-billing-cml-billing-detail-handling-extra'].unselectAllInternal()
            },

            selectionChanged(ev) {

                this.rowsSelection = [];
                this.idCodeLkupsSelections  = [];
                this.rowsSelection = ev.selectedRows;

                this.rowsSelection.forEach((item) => {
                    this.idCodeLkupsSelections.push(item.idDetail_ExtraHandling);

                });
 

            },
           
            backForm() {
                var params = this.$onRandom(this.$route.params.idBillingHeader);
                window.location.href = "/billing-cml/billing/header/detail/"+params;
            },

            toCurrency (value) {
                if (typeof value !== "number") {
                    return value;
                }
                var formatter = new Intl.NumberFormat('en-US', {
                    style: 'currency',
                    currency: 'IDR'
                });
                return formatter.format(value);
            },
 
          
            toNumber (value) {
                if (typeof value !== "number") {
                    return value;
                }
            
                return Number(value).toLocaleString();
            },
            downloadData() {
                var params = this.$onBehind(this.$route.params.idBillingDetail);
                const baseURI = this.$settings.endPointBilling + "dashboard/cml-billing/billing/bt-billing-detail-extra-handling-charge/" + params[0];
                this.isLoading = true;
                var CurrentDate = this.$moment().format("DD_MM_YYYY_HH_mm_ss");
                var file_name = "download_" + CurrentDate + ".xlsx";
       
                return this.$http
                .get(
                    baseURI +
                    `?idDetail_ExtraHandling=${this.serverParams.columnFilters.idDetail_ExtraHandling}&transactionType=${this.serverParams.columnFilters.transactionType}&nik=${this.serverParams.columnFilters.nik}&employeeName=${this.serverParams.columnFilters.employeeName}&editwho=${this.serverParams.columnFilters.editwho}&status=${this.serverParams.columnFilters.status}&download=download`,
                    {
                    responseType: "blob",
                    }
                )
                .then((response) => {
                    this.isLoading = false;
                    var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                    var fileLink = document.createElement("a");
        
                    fileLink.href = fileURL;
                    fileLink.setAttribute("download", file_name);
                    document.body.appendChild(fileLink);
                    fileLink.click();
                    this.fade(false);
                });
            },
    
     
    
            // load items is what brings back the rows from server
            loadItems() {

                var params = this.$onBehind(this.$route.params.idBillingDetail);
                const baseURI = this.$settings.endPointBilling + "dashboard/cml-billing/billing/bt-billing-detail-extra-handling-charge/" + params[0];
                this.isLoading = true;

        
                return this.$http
                .get(
                    baseURI +
                    `?limit=${this.serverParams.per_page}&page=${this.serverParams.page}&sort_field=${this.serverParams.sort.field}&sort_type=${this.serverParams.sort.type}&idDetail_ExtraHandling=${this.serverParams.columnFilters.idDetail_ExtraHandling}&transactionType=${this.serverParams.columnFilters.transactionType}&nik=${this.serverParams.columnFilters.nik}&employeeName=${this.serverParams.columnFilters.employeeName}&editwho=${this.serverParams.columnFilters.editwho}&status=${this.serverParams.columnFilters.status}`,
                    { timeout: 60000 })
                .then((response) => {
                    this.isLoading = false;
                    this.rows = response.data.datas.data;
                    this.totalRecords = response.data.datas.total;
                }).catch((error) => {
                        this.loading();
                           
        if(error.code == "ECONNABORTED"){
            this.error(this.$t("check_internet_connection_txt"));
            
        }else{

            if (error.response) {
                if(error.response.status === 422) {
                    this.errors = error.response.data.errors;
                    this.resultError(error.response.data.errors);
                }else if (error.response.status === 401) {
                    this.logout();
                } else if (error.response.status === 403) {
                    this.$router.push("/authorized-error");
                }else if (error.response.status === 500) {
                    this.$router.push('/server-error');
                }else{
                    this.$router.push('/page-not-found');
                }
            }

        }
                    });
            },
        
            updateParams(newProps) {
                this.serverParams = Object.assign({}, this.serverParams, newProps);
                this.loadItems();
            },
        
            onColumnFilter(params) {
                this.updateParams(params);
            },
    
            onPageChange(params) {
                this.updateParams({ page: params.currentPage });
            },
    
            onSortChange(params) {
                this.updateParams({
                sort: {
                    type: params[0].type,
                    field: params[0].field,
                },
                });
            },
    
            onPerPageChange(params) {
                this.updateParams({ per_page: params.currentPerPage });
            },
    
            resultError(data) {
                var count = Object.keys(data).length;
                for (var x = 0; x < count; x++) {
                var nameOb = Object.keys(data)[x];
                var objectData = data[nameOb];
                for (var y = 0; y < objectData.length; y++) {
                    this.error(objectData[y]);
                }
                }
            },
    
            success(kata) {
                const Toast = this.$swal.mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
                didOpen: (toast) => {
                    toast.addEventListener("mouseenter", this.$swal.stopTimer);
                    toast.addEventListener("mouseleave", this.$swal.resumeTimer);
                },
                });
                Toast.fire({
                icon: "success",
                title: kata,
                });
            },
    
            error(kata) {
                const Toast = this.$swal.mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
                didOpen: (toast) => {
                    toast.addEventListener("mouseenter", this.$swal.stopTimer);
                    toast.addEventListener("mouseleave", this.$swal.resumeTimer);
                },
                });
                Toast.fire({
                icon: "error",
                title: kata,
                });
            },
    
            fade(sType) {
                this.isLoading = sType;
            },
        
            loading() {
                this.fade(true);
                setTimeout(() => {
                this.isLoading = false;
                }, 1000); // hide the message after 3 seconds
            },
        
            fetchIt() {
                const userDatas     = this.$getUserInfo();
                this.detailUser     = userDatas.sub;
                // this.permision_role = userDatas.sub.permision_role;
                let rolePermision = [];
                userDatas.sub.permision_role.forEach(function(permision){
                if(permision.permission.controller == 'BillingCmlController'){
                    rolePermision = permision;
                }
                });
        
                if(!rolePermision.method_read){
                this.$router.push("/authorized-error");
                }
                this.permision_role = rolePermision;
        
                this.loadData();
            },


            loadData() {
                this.isLoading = true;

                var params = this.$onBehind(this.$route.params.idBillingDetail);

                const baseURI = this.$settings.endPointBilling + "dashboard/cml-billing/billing/bt-billing-detail-detail/" + params[0];
                return this.$http.get(baseURI,{ timeout: 60000 }).then((response) => {
                    
                    this.isLoading = false;
                    this.forms                      = response.data.datas;
                    this.forms.amountCategory       = this.toCurrency(response.data.datas.amountCategory)
                    this.forms.rate                 = this.toCurrency(response.data.datas.rate)
                    this.formsHeader                = response.data.datas.bm_billing_header;
                    
                }).catch(error => {
                    this.isLoading = false;
                       
        if(error.code == "ECONNABORTED"){
            this.error(this.$t("check_internet_connection_txt"));
            
        }else{

            if (error.response) {
                if(error.response.status === 422) {
                    this.errors = error.response.data.errors;
                    this.resultError(error.response.data.errors);
                }else if (error.response.status === 401) {
                    this.logout();
                } else if (error.response.status === 403) {
                    this.$router.push("/authorized-error");
                }else if (error.response.status === 500) {
                    this.$router.push('/server-error');
                }else{
                    this.$router.push('/page-not-found');
                }
            }

        }


                });
            },

      logout(){

          const baseURI = this.$settings.endPoint + "user/logout";
          this.$http.get(baseURI, { timeout: 60000 }).then((response) => {
              
          console.log(response);

          });

          this.$logoutUser();
          window.location.href = '/';
      },

    
        },
        events: {},
        created: function () {},
        mounted() {
            this.fetchIt();
            this.loading();
        },
    };

</script>
<style scoped>
  .blur-content{
    filter: blur(5px); 
  }
</style>